/* eslint-disable max-len */
/* eslint no-nested-ternary: 0 */
import {
  Container,
  Button,
  Dimmer,
  Dropdown,
  Grid,
  Loader,
  Label,
  Icon,
  Menu,
  Table,
} from 'semantic-ui-react';
import { Link } from 'react-router';
import { withTranslation } from 'react-i18next';
import React, {
  Component,
} from 'react';
import PropTypes from 'prop-types';
import { push, replace } from 'react-router-redux';
import { connect } from 'react-redux';
import qs from 'qs';
import { decodeSearch, encodeSearch } from '../../utils/url';
import isNumber from '../../utils/numbers/isNumber';
import { flashErrorMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import config from '../../../config';
import NavBar from '../../components/NavBar';
import PageNav from '../../components/PageNav';
import SearchFilter from '../../components/SearchFilter';
import SortButton from '../../components/SortButton';
import { SelectList } from '../../components/Filters';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import { ignoreGroupIDs } from '../../constants/groups';

class StaffList extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
    }),
    auth: PropTypes.shape({
      email: PropTypes.string,
      isBranchLeaderSupervisor: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
    }),
    t: PropTypes.func,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })
  static getPropsToState = (props) => {
    const query = decodeSearch(props.location.search);
    const statusID = query.statusID || '';
    const roleID = query.roleID || '';
    const companyBranchID = query.companyBranchID || '';
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 768;
    const returnStates = {
      statusID,
      roleID,
      companyBranchID,
      isMobile,
      advanceFilter: false,
    };
    return returnStates;
  }
  constructor(props) {
    super(props);
    const state = StaffList.getPropsToState(props);
    const query = decodeSearch(props.location.search);
    const search = query.search || '';
    this.state = {
      ...state,
      data: [],
      count: 0,
      limit: 0,
      offset: 0,
      currentPage: parseInt(query.page, 10) || 1,
      search,
      token: null,
      loading: true,
      branches: [],
      companyBranches: [],
      businessUnitFilter: false,
    };
  }
  componentDidMount() {
    const { store } = this.context;
    const { query } = this.props.location;
    window.addEventListener('resize', this.handleResize, false);
    this.fetchCompanyBranches();
    if (!isNumber(query.page) || query.page <= 0) {
      delete query.page;
    }
    store.dispatch(replace(`/users/?${qs.stringify(query)}`));
  }
  componentWillReceiveProps(nextProps) {
    const state = StaffList.getPropsToState(nextProps);
    this.setState({ ...state }, () => {
      const { query } = nextProps.location;
      this.fetchStaffs(query);
      if (
          (query.statusID && query.statusID.length > 0) ||
          (query.roleID && query.roleID.length > 0) ||
          (query.companyBranchID && query.companyBranchID.length > 0)
        ) {
        this.setState({
          advanceFilter: true,
        });
      }
    });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  setStaffs(data = []) {
    return new Promise((res) => {
      this.setState({
        data: data || [],
      }, () => {
        res(data);
      });
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  getRoles = (data) => {
    const rolesArr = [];
    data.user.groups.forEach((g) => {
      // ignore CC & analytics role in SR
      if (ignoreGroupIDs.includes(g.id)) return;
      rolesArr.push(g.id);
    });
    rolesArr.sort();
    return String(rolesArr.toString());
  }
  getRoleText = (data) => {
    const role = this.roles.find(g => g.value === this.getRoles(data));
    if (role && role.text) {
      return role.text;
    }
    if (role && role.value === '10') {
      if (data.companyBranch && data.companyBranch.isExternal) return 'Agent';
      return 'Staff';
    }
    return '';
  }
  getValueName = (value, arr) => {
    const { t } = this.props;
    const valueName = arr.find(vn => vn.value === value);
    if (valueName && valueName.text) {
      return t(valueName.text, { ns: TRANSLATION_FILES.constants });
    }
    return '';
  }
  hasAccess(check = false) {
    if (
      this.props.auth.isBranchLeaderSupervisor ||
      this.props.auth.isHeadquarters ||
      this.props.auth.isSuperAdmin
    ) {
      return true;
    }
    return check;
  }
  hasEditBUAccess(check = false) {
    if (
      this.props.auth.isHeadquarters ||
      this.props.auth.isSuperAdmin
    ) {
      return true;
    }
    return check;
  }
  async fetchStaffs(q) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const query = Object.assign({}, q);
    if (!query.page || !isNumber(query.page) || query.page <= 0) {
      query.page = 1;
    }
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/staffs/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10);
      const data = await res.json();
      await this.setStaffs(data);

      // handle token.. etc
      await this.setComponentState({
        token,
        count,
        limit,
        offset,
      });
    }
    await this.setLoading(false);
  }
  async fetchCompanyBranches() {
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/company_branches/?page=all`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const branches = await res.json();
      await this.setState({
        branches: branches ? branches.map((ul) => {
          const branch = { text: ul.name, name: ul.shortName, value: ul.id.toString(), description: ul.isExternal ? 'Agency' : '' };
          return branch;
        }) : [],
        companyBranches: branches,
      });
    }
  }
  handleChangePage = (currentPage) => {
    const query = decodeSearch(this.props.location.search);
    query.page = currentPage;
    this.setState({
      currentPage,
    });
    this.replaceQuery(query);
  }
  handleSortData = (sortColumn, sortDirection) => {
    const query = decodeSearch(this.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    this.replaceQuery(query, true);
  }
  handleClearFilter = (...queryArray) => {
    let hasQuery = false;
    const query = decodeSearch(this.props.location.search);
    const filterArray = [...queryArray];
    let states;
    filterArray.forEach((filter) => {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
        states = {
          [filter]: '',
        };
      }
    });
    this.setState({
      ...states,
    }, () => {
      if (hasQuery) {
        this.replaceQuery(query, true);
      }
    });
  }
  handleFilterOnChange = (value, queryName) => {
    const query = decodeSearch(this.props.location.search);
    query[queryName] = value;
    this.setState({
      [queryName]: value,
      businessUnitFilter: false,
    });
    this.replaceQuery(query, true);
  }
  handleSetAdvanceFilter = (advanceFilter) => {
    this.setState({
      advanceFilter,
    });
  }
  handleOpenFilterFusinessUnit = () => this.setState({ advanceFilter: !this.state.advanceFilter, businessUnitFilter: true });
  handleResize = () => {
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 768;
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
  }
  handleManageClick = (e, data) => {
    e.preventDefault();
    const { store } = this.context;
    store.dispatch(push(`/users/${data.value}`));
  }
  replaceQuery(query, resetPage = false) {
    const { store } = this.context;
    const queryNew = query;
    if (resetPage) {
      queryNew.page = 1;
    }
    store.dispatch(push(`/users/?${encodeSearch(query)}`));
  }
  sortItems = [
    {
      text: 'Newest',
      icon: 'sort numeric descending',
      sortColumn: 'affiliate.created_at',
      sortDirection: 'desc',
    },
    {
      text: 'Oldest',
      icon: 'sort numeric ascending',
      sortColumn: 'affiliate.created_at',
      sortDirection: 'asc',
    },
    {
      text: 'Name Ascending',
      icon: 'sort alphabet ascending',
      sortColumn: 'affiliate.name',
      sortDirection: 'asc',
    },
    {
      text: 'Name Descending',
      icon: 'sort alphabet descending',
      sortColumn: 'affiliate.name',
      sortDirection: 'desc',
    },
  ];
  roles = [
    { text: 'Headquarters', value: '10,6' },
    { text: 'Supervisor', value: '10,11,12,13' },
    { text: 'Sales Manager', value: '10,11,13' },
    { text: 'Sales Admin', value: '10,11' },
    { text: '', value: '10' },
    { text: 'Agency Admin', value: '10,21' },
    { text: 'Agent Leader', value: '10,17' },
    { text: 'Basic Siteplan', value: '16' },
  ];
  userStateses = [
    { value: '100', text: 'Active' },
    // { value: '502', text: 'Delisted' },
    { value: '503', text: 'Suspended' },
  ]
  filterRoles = [
    { text: 'Headquarters', value: '1', disabled: !(this.props.auth.isSuperAdmin || this.props.auth.isHeadquarters) },
    { text: 'Supervisor', value: '2' },
    { text: 'Sales Manager', value: '3' },
    { text: 'Sales Admin', value: '4' },
    { text: 'Staff', value: '5' },
    { text: 'Agent Leader', value: '9' },
    { text: 'Agency Admin', value: '10' },
    { text: 'Agent', value: '6' },
    { text: 'Basic Siteplan', value: '7' },
  ];
  render() {
    const { store } = this.context;
    const { t } = this.props;
    const query = decodeSearch(this.props.location.search);
    const exportItems = [
      {
        text: 'Excel',
        href: `${config.get('bookApiURL')}/staffs/export/?${qs.stringify(Object.assign(query, { fileType: 'excel' }))}`,
      },
      {
        text: 'CSV',
        href: `${config.get('bookApiURL')}/staffs/export/?${qs.stringify(Object.assign(query, { fileType: 'csv' }))}`,
      },
    ];
    return (
      <Container>
        <NavBar
          header={(this.state.count === 0) ? t('Users') : <span>{t('Users')} &nbsp;<Label size="large">{this.state.count}</Label></span>}
          rightNav={
            <Menu className="transparentMenu">
              <Menu.Item fitted>
                <Dropdown item text={t('Manage')}>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={this.handleManageClick}
                      value="import/"
                    >
                      {t('Import Users', { ns: TRANSLATION_FILES.screens })}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Menu.Item>
              <Menu.Item fitted>
                <Button
                  primary
                  icon="add"
                  content={t('User', { ns: TRANSLATION_FILES.screens })}
                  disabled={this.state.loading}
                  onClick={() => store.dispatch(push('/users/new/'))}
                />
              </Menu.Item>
            </Menu>
          }
        />
        <Grid>
          <Grid.Row>
            <Grid.Column width={16}>
              {/* Search Filters */}
              <SearchFilter
                advanceFilter={this.state.advanceFilter}
                isLoading={this.state.loading}
                onChange={this.handleFilterOnChange}
                onClose={this.handleClearFilter}
                search={this.state.search}
                setAdvanceFilter={this.handleSetAdvanceFilter}
                leftNav={(
                  <PageNav
                    currentPage={this.state.currentPage}
                    count={this.state.count}
                    limit={this.state.limit}
                    offset={this.state.offset}
                    dataSize={this.state.data.length}
                    loading={this.state.loading}
                    onChange={this.handleChangePage}
                  />
                )}
                rightNav={(
                  <div>
                    {this.state.isMobile &&
                      <Button
                        color="teal"
                        icon="group"
                        onClick={() => store.dispatch(push('/business_units/'))}
                      />
                    }
                    {this.hasAccess() &&
                      <SortButton
                        icon="download"
                        loading={this.state.loading}
                        items={exportItems}
                      />
                    }
                    <SortButton
                      loading={this.state.loading}
                      items={this.sortItems}
                      onSort={this.handleSortData}
                    />
                  </div>
                )}
              >
                <SelectList
                  filterName="roleID"
                  headerText={null}
                  onChange={this.handleFilterOnChange}
                  onClose={this.handleClearFilter}
                  options={this.filterRoles.map(r => ({
                    ...r,
                    text: t(r.text, { ns: TRANSLATION_FILES.constants }),
                  }))}
                  placeholder={t('Select Access Role')}
                  value={this.state.roleID}
                />
                <SelectList
                  filterName="statusID"
                  headerText={null}
                  onChange={this.handleFilterOnChange}
                  onClose={this.handleClearFilter}
                  options={this.userStateses.map(s => ({
                    ...s,
                    text: t(s.text, { ns: TRANSLATION_FILES.constants }),
                  }))}
                  placeholder={t('Select Access Status')}
                  value={this.state.statusID}
                />
                <SelectList
                  filterName="companyBranchID"
                  headerText={null}
                  onChange={this.handleFilterOnChange}
                  onClose={this.handleClearFilter}
                  options={this.state.branches}
                  placeholder={t('Select Business Unit')}
                  value={this.state.companyBranchID}
                  hasSearch
                  onFocus={this.state.businessUnitFilter}
                />
              </SearchFilter>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row only="computer tablet" textAlign="center" style={{ paddingBottom: '0px' }}>
            <Grid.Column computer={4} tablet={4} />
            <Grid.Column className="manage_user_bu_search_grid" computer={4} tablet={4}>
              <Button
                content={t('Filter by Business Unit')}
                disabled={this.state.loading}
                onClick={this.handleOpenFilterFusinessUnit}
              />
            </Grid.Column>
            <Grid.Column computer={4} tablet={4}>
              {this.hasEditBUAccess() ? (
                <Button
                  primary
                  content={t('Edit Business Units')}
                  disabled={this.state.loading}
                  onClick={() => store.dispatch(push('/business_units/'))}
                />
              ) : ''}
            </Grid.Column>
            <Grid.Column computer={4} tablet={4} />
          </Grid.Row>
          <Grid.Row style={{ paddingTop: '0px' }}>
            <Grid.Column>
              <Dimmer
                inverted
                active={this.state.loading && this.state.data.length > 0}
              >
                <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
              </Dimmer>
              <Table
                celled
                selectable
                compact
                className="app--tablelist"
              >
                <Table.Header className="mobile-hide">
                  <Table.Row>
                    <Table.HeaderCell>{t('Name')}</Table.HeaderCell>
                    <Table.HeaderCell>{t('Email')}</Table.HeaderCell>
                    <Table.HeaderCell>{t('Mobile')}</Table.HeaderCell>
                    <Table.HeaderCell>{t('Business Unit')}</Table.HeaderCell>
                    <Table.HeaderCell>{t('Access')}</Table.HeaderCell>
                    <Table.HeaderCell>{t('Status')}</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {
                    this.state.data.length > 0 ?
                      this.state.data.map((data, idx) => (
                        <Table.Row
                          key={idx}
                          title={t('View User')}
                          onClick={() => store.dispatch(push(`/users/${data.id}/`))}
                          negative={data.user && data.user.statusID !== '100'}
                        >
                          <Table.Cell>
                            <Icon name="user" className="computer-hide" />
                            <Link to={`/users/${data.id}/`}>
                              <b>{data.name}</b>&nbsp;
                              <Icon style={{ float: 'right' }} name="chevron right" className="computer-hide" />
                            </Link>
                            {
                              this.props.auth.email === data.email ?
                                <Label size="mini" color="blue">{t('You')}</Label> : ''
                            }
                          </Table.Cell>
                          <Table.Cell>
                            <Icon name="mail" className="computer-hide" />{data.email}
                          </Table.Cell>
                          <Table.Cell collapsing>
                            <Icon name="phone" className="computer-hide" />{data.mobilePrefix}{data.mobile}
                          </Table.Cell>
                          <Table.Cell>
                            <Icon name="home" className="computer-hide" />
                            {
                              data.companyBranch ?
                                (
                                  <span>
                                    {data.companyBranch.name}&nbsp;
                                    {data.companyBranch.isExternal ? <Label size="mini" color="teal">{t('Agency')}</Label> : ''}
                                  </span>
                                )
                                : ''
                            }
                          </Table.Cell>
                          <Table.Cell>
                            <Icon name="wrench" className="computer-hide" />
                            {
                              data.user && data.user.groups && data.user.groups.length > 0 ?
                              this.getRoleText(data) !== '' && t(this.getRoleText(data), { ns: TRANSLATION_FILES.constants })
                              : null
                            }
                            <span className="computer-hide">
                              &nbsp;{data.user ? <Label size="mini" color={(data.user && data.user.statusID !== '100') ? 'red' : null}>{this.getValueName(data.user.statusID, this.userStateses)}</Label> : ''}
                            </span>
                          </Table.Cell>
                          <Table.Cell collapsing>
                            <span className="mobile-hide">
                              {data.user && this.getValueName(data.user.statusID, this.userStateses)}
                            </span>
                          </Table.Cell>
                        </Table.Row>
                      ))
                    :
                      <Table.Row>
                        <Table.Cell colSpan="6" textAlign="center">
                          {
                            this.state.loading ?
                              <Loader active inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                            : <p>{t('No users found')}.</p>
                          }
                        </Table.Cell>
                      </Table.Row>
                  }
                </Table.Body>
                <Table.Footer>
                  <Table.Row>
                    <Table.HeaderCell colSpan="6" textAlign="center">
                      <PageNav
                        upward
                        currentPage={this.state.currentPage}
                        count={this.state.count}
                        limit={this.state.limit}
                        offset={this.state.offset}
                        dataSize={this.state.data.length}
                        loading={this.state.loading}
                        onChange={this.handleChangePage}
                      />
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Footer>
              </Table>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default withTranslation(namespaces)(connect(StaffList.mapStateToProps)(StaffList));



// WEBPACK FOOTER //
// ./src/containers/Staffs/List.jsx